<template>
  <div class="home-account">
    <!-- Banner removed -->
    <div class="place-content-left">
      <div class="text-container" v-if="account">
        <!-- Добавлена иконка стрелки для указания кликабельности (только на главной странице) -->
        <div class="arrow-indicator" v-if="$route.name === 'Home'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 18L15.5 12L9.5 6" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="account-header">
          <div class="account-number">№ {{ account.ls }}</div>
          <div class="account-street">{{ account.streetName }} {{ account.building }}</div>
          <template v-if="account.appartment">
            <div class="account-apartment">{{ $t("components.accounts.apartment") }} {{ account.appartment }}</div>
          </template>
          <div class="account-city">{{ account.city }}</div>
          <template v-if="showBalance">
            <div class="account-balance">
              Заборгованість: <span
                :class="
                  account.balance === 0
                    ? ''
                    : account.balance > 0
                    ? 'positive-balance'
                    : 'negative-balance'
                "
            >{{ Math.abs(account.balance) }}</span> {{ $t("components.accounts.currency") }}
            </div>
          </template>
        </div>
        <template v-if="$route.name === 'Account'">
          <div class="services-info-block">
            <div class="service-block">
              <div class="service-title">Газопостачання</div>
              <div class="service-company">ГК Нафтогаз України, ТОВ</div>
              <div class="service-region">{{ account.city }} область</div>
              <div class="service-note">За доставку газу з 01.08.2023</div>
            </div>
            <div class="service-block">
              <div class="service-title">Газорозподільні мережі України, ТОВ</div>
              <div class="service-region">{{ account.city }} міська філія – доставка/розподіл газу</div>
            </div>
          </div>
        </template>
        <template v-if="$route.name === 'Pay'">
          <div class="mt-10 checkbox-group">
            <div class="service-item">
              <label class="checkbox-label">
                <input
                    type="checkbox"
                    v-model="payNaftogaz"
                    @change="handleNaftogazChange"
                    class="checkbox-input"
                />
                <span class="checkmark"></span>
                <div class="service-label">
                  <span>ГК "Нафтогаз України"</span>
                  <span class="account-number">{{ account.ls }}</span>
                  <span
                      :class="['debt-amount', account.balance > 0 ? 'positive' : 'negative']"
                      v-if="account.balance !== 0"
                  >
                    ({{
                      account.balance > 0
                          ? `${$t(
                          "components.accounts.debt"
                          )}: ${account.balance} ${$t(
                          "components.accounts.currency"
                          )}`
                          : `${$t("components.accounts.overpay")}: ${Math.abs(
                          account.balance
                          )} ${$t("components.accounts.currency")}`
                    }})
                  </span>
                </div>
              </label>
              <itserve-input
                  v-if="payNaftogaz"
                  v-model.number="naftogazAmount"
                  type="number"
                  inputmode="decimal"
                  placeholder="Сума для Нафтогазу"
                  name="naftogazAmount"
                  class="amount-input"
                  min="0"
                  @input="$emit('update:services', getServicesData())"
                  :key="'naftogaz-input-' + inputKey"
              />
            </div>
            <div class="service-item">
              <label class="checkbox-label">
                <input
                    type="checkbox"
                    v-model="payDistribution"
                    @change="handleDistributionChange"
                    class="checkbox-input"
                />
                <span class="checkmark"></span>
                <div class="service-label">
                  <span>Газорозподільні мережі України</span>
                  <span class="account-number">{{ account.lsDistrib }}</span>
                  <span
                      :class="['debt-amount', distributionDebt > 0 ? 'positive' : 'negative']"
                      v-if="account.lsDistrib"
                  >
                    ({{
                      distributionDebt > 0
                          ? `${$t(
                          "components.accounts.debt"
                          )}: ${distributionDebt} ${$t(
                          "components.accounts.currency"
                          )}`
                          : `${$t("components.accounts.overpay")}: ${Math.abs(
                          distributionDebt
                          )} ${$t("components.accounts.currency")}`
                    }})
                  </span>
                </div>
              </label>
              <itserve-input
                  v-if="payDistribution"
                  v-model.number="distributionAmount"
                  type="number"
                  inputmode="decimal"
                  :placeholder="'Сума для газорозподільних мереж'"
                  name="distributionAmount"
                  class="amount-input"
                  min="0"
                  @input="$emit('update:services', getServicesData())"
                  :key="'distribution-input-' + inputKey"
              />
            </div>
          </div>
        </template>
      </div>
      <simple-dialog
          v-model="showDialog"
          :success="true"
          @change="runPayment"
          :title="dialogMessage"
      />
      <add-ls-distrib
          :show.sync="showLsDistribDialog"
          @close="handleCloseLsDistrib"
      />
    </div>
  </div>
</template>
<script>
import SimpleDialog from "@/components/content/SimpleDialog";
import AddLsDistrib from "@/components/popup/addLsDistrib";
export default {
  name: "Account",
  components: {
    SimpleDialog,
    AddLsDistrib,
    ItserveInput: () => import("@/components/forms/ItserveInput"),
  },
  props: {
    updateAmount: Function,
    account: Object,
    value: {
      type: Object,
      default: () => ({
        services: [],
        totalAmount: 0,
      }),
    },
    type: {
      type: String,
      default: "regular",
    },
    showBalance: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$store.commit("Auth/SET_ACCOUNT_NUMBER", this.account.ls);
  },
  computed: {
    cards() {
      return this.$store.state.Payment.cards;
    },
  },
  data() {
    return {
      payNaftogaz: true,
      payDistribution: false,
      naftogazAmount: 0,
      distributionAmount: 0,
      distributionDebt: 0,
      showDialog: false,
      showLsDistribDialog: false,
      inputKey: 0, // Ключ для пересоздания компонента ввода
      loadingDistributionDebt: false,
      dialogMessage: '', // Текст уведомления для simple-dialog
      // Удалено свойство invalidDistributionAccount, теперь используем флаг из Vuex
    };
  },
  async mounted() {
    // Автоматически устанавливаем сумму к оплате для газоснабжения
    this.initializeNaftogazAmount();

    // Загружаем задолженность по распределению газа только на странице аккаунта
    if (this.$route.name === 'Account') {
      await this.loadDistributionDebt(); // В методе уже есть проверка this.account.lsDistrib
      console.log('Значение долга после загрузки:', this.distributionDebt);
      // Не нужно устанавливать значения вручную, это делает watcher
    }
  },
  updated() {
    // При обновлении компонента проверяем, что сумма установлена правильно
    if (this.payNaftogaz && this.naftogazAmount === 0 && this.account.balance > 0) {
      this.initializeNaftogazAmount();
    }
  },
  watch: {
    payNaftogaz() {
      this.updateTotal();
    },
    payDistribution() {
      this.updateTotal();
    },
    // Следим за изменениями в хранилище Vuex для текущего региона
    '$store.state.Auth.app_id': {
      handler() {
        // При изменении региона сбрасываем данные о задолженности
        this.resetDistributionDebt();
      }
    },
    // Следим за изменениями в хранилище Vuex для Харькова
    '$store.state.PaymentDistributionHarkiv.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Харьков
        if (this.$store.state.Auth.app_id === "kharkiv.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionHarkiv.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Черкасс
    '$store.state.PaymentDistributionCherkasy.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Черкассы
        if (this.$store.state.Auth.app_id === "cherkasy.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionCherkasy.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Чернигова
    '$store.state.PaymentDistributionChernihiv.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Чернигов
        if (this.$store.state.Auth.app_id === "chernihiv.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionChernihiv.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Черновцов
    '$store.state.PaymentDistributionChernivtsi.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Черновцы
        if (this.$store.state.Auth.app_id === "chernivtsi.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionChernivtsi.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Днепра
    '$store.state.PaymentDistributionDnipro.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Днепр
        if (this.$store.state.Auth.app_id === "dnipro.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionDnipro.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Хмельницкого
    '$store.state.PaymentDistributionKhmelnytskyi.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Хмельницкий
        if (this.$store.state.Auth.app_id === "khmelnytskyi.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionKhmelnytskyi.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Кировограда
    '$store.state.PaymentDistributionKirovograd.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Кировоград
        if (this.$store.state.Auth.app_id === "kirovograd.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionKirovograd.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Киева
    '$store.state.PaymentDistributionKyiv.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Киев
        if (this.$store.state.Auth.app_id === "kyiv.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionKyiv.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Львова
    '$store.state.PaymentDistributionLviv.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Львов
        if (this.$store.state.Auth.app_id === "lviv.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionLviv.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Николаева
    '$store.state.PaymentDistributionMykolaiv.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "mykolaiv.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionMykolaiv.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Прикарпатья
    '$store.state.PaymentDistributionPrykarpattya.distributionDebt': {
      handler(newValue) {
        console.log("CHLENIX PaymentDistributionPrykarpattya: ", this.$store.state.PaymentDistributionPrykarpattya.distributionDebt)
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "prykarpattya.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionPrykarpattya.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Ровно
    '$store.state.PaymentDistributionRivne.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "rivne.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionRivne.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Сумы
    '$store.state.PaymentDistributionSumy.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "sumy.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionSumy.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Тернополь
    '$store.state.PaymentDistributionTernopil.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "ternopil.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionTernopil.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Винница
    '$store.state.PaymentDistributionVinnytsia.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "vinnytsia.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionVinnytsia.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Волынь
    '$store.state.PaymentDistributionVolyn.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "volyn.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionVolyn.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    // Следим за изменениями в хранилище Vuex для Закарпатье
    '$store.state.PaymentDistributionZakarpattya.distributionDebt': {
      handler(newValue) {
        // Проверяем, что текущий регион - Николаев
        if (this.$store.state.Auth.app_id === "zakarpattya.gas") {
          // Проверяем флаг неверного счета перед установкой значений
          const invalidAccount = this.$store.state.PaymentDistributionZakarpattya.invalidAccount;

          // Устанавливаем значения только если счет действителен
          if (!invalidAccount) {
            this.distributionDebt = newValue;

            // Автоматически активируем чекбокс только если есть счет и есть лицевой счет для распределения
            if (this.$store.state.Auth.account?.lsDistrib) {
              this.payDistribution = true;

              // Если есть задолженность, устанавливаем её значение, иначе 100 (аналогично Нафтогазу)
              if (newValue > 0) {
                this.distributionAmount = parseFloat(newValue.toFixed(2));
              } else {
                this.distributionAmount = 100;
              }

              this.$emit("update:services", this.getServicesData());
            }
          } else {
            // Если счет неверный, сбрасываем значения
            this.distributionDebt = 0;
            this.distributionAmount = 0;
            this.payDistribution = false;
          }
        }
      },
      immediate: true
    },
    account: {
      handler(newAccount, oldAccount) {
        // При изменении аккаунта обновляем сумму к оплате
        this.initializeNaftogazAmount();

        // Проверяем, что оба аккаунта существуют и произошла реальная смена счета
        if (oldAccount && newAccount &&
            (oldAccount.ls !== newAccount.ls ||
                oldAccount.lsDistrib !== newAccount.lsDistrib)) {
          console.log('Смена счета или счета распределения:',
              oldAccount.ls, '->', newAccount.ls,
              'или', oldAccount.lsDistrib, '->', newAccount.lsDistrib);
          
          // Сбрасываем данные о задолженности
          this.resetDistributionDebt();

          // Загружаем данные только если:
          // 1. Мы находимся на странице аккаунта или на странице оплаты
          // 2. Изменился счет распределения
          // 3. Новый счет распределения существует
          // 4. Проходит проверку shouldLoadDistributionDebt
          const validRoutes = ['Account', 'Pay'];
          if (validRoutes.includes(this.$route.name) && 
              oldAccount.lsDistrib !== newAccount.lsDistrib && 
              newAccount.lsDistrib && 
              this.shouldLoadDistributionDebt(newAccount)) {
            console.log('Загрузка долга для нового счета распределения:', newAccount.lsDistrib, 'на странице', this.$route.name);
            this.loadDistributionDebt();
          }
        }
      },
      deep: true
    },
    '$route': {
      handler(to, from) {
        // Сбрасываем данные о задолженности ТОЛЬКО при переходе с другой страницы на домашнюю
        if (to.name === 'Home' && from.name) {
          this.resetDistributionDebt();
        }
      },
      immediate: false
    }
  },
  methods: {
    noticeAppName() {
      let id = this.$store.state.Auth.app_id;
      let text;

      switch (id) {
        case "zaporizhzhia.gas":
          text = "Запоріжжя"
          break;
        case "lviv.gas":
          text = "Львів"
          break;
        case "volyn.gas":
          text = "Волинь"
          break;
        case "kherson.gas":
          text = "Херсон"
          break;
        case "ternopil.gas":
          text = "Тернопіль"
          break;
        case "chernivtsi.gas":
          text = "Чернівці"
          break;
        case "prykarpattya.gas":
          text = "Прикарпаття"
          break;
        case "zakarpattya.gas":
          text = "Закарпаття"
          break;
        case "rivne.gas":
          text = "Рівне"
          break;
        case "khmelnytskyi.gas":
          text = "Хмельницький"
          break;
        case "vinnytsia.gas":
          text = "Вінниця"
          break;
        case "cherkasy.gas":
          text = "Черкаси"
          break;
        case "chernihiv.gas":
          text = "Чернігів"
          break;
        case "mykolaiv.gas":
          text = "Миколаїв"
          break;
        case "dnipro.gas":
          text = "Дніпро"
          break;
        case "poltava.gas":
          text = "Полтава"
          break;
        case "odesa.gas":
          text = "Одеса"
          break;
        case "zhytomyr.gas":
          text = "Житомир"
          break;
        case "kirovograd.gas":
          text = "Кіровоград"
          break;
        case "sumy.gas":
          text = "Суми"
          break;
        case "kyiv.gas":
          text = "Київ"
          break;
        case "kharkiv.gas":
          text = "Харків"
          break;
      }
      this.appName = text;
    },
    openCard() {
      this.$router.push({ name: "CardInstructionPage" });
    },
    updateTimerDisplay() {
      const hours = Math.floor(this.localSecondsLeft / 3600);
      const minutes = Math.floor((this.localSecondsLeft % 3600) / 60);
      const seconds = this.localSecondsLeft % 60;

      this.hours = hours.toString().padStart(2, '0');
      this.minutes = minutes.toString().padStart(2, '0');
      this.seconds = seconds.toString().padStart(2, '0');
    },
    showTerms() {
      // При нажатии на кнопку «Умови акції» переходим на страницу с условиями
      this.$router.push({ name: 'TermsPage' });
    },
    resetDistributionDebt() {
      // Определяем текущий модуль распределения в зависимости от appId
      const appId = this.$store.state.Auth.app_id;
      let distributionModule = this.getDistributionModule(appId);
      
      // Сбрасываем данные о задолженности только для активного модуля
      if (distributionModule) {
        this.$store.commit(`${distributionModule}/RESET_PAYMENT_STATE`);
        console.log(`Сброс данных о задолженности для модуля ${distributionModule}`);
      }

      // Сбрасываем состояние чекбокса и сумму
      this.payDistribution = false;
      this.distributionAmount = 0;
    },
    
    // Вспомогательный метод для получения названия модуля распределения
    getDistributionModule(appId) {
      let distributionModule = "PaymentDistributionHarkiv"; // По умолчанию Харьков
      
      if (appId === "cherkasy.gas") {
        distributionModule = "PaymentDistributionCherkasy";
      } else if (appId === "chernihiv.gas") {
        distributionModule = "PaymentDistributionChernihiv";
      } else if (appId === "chernivtsi.gas") {
        distributionModule = "PaymentDistributionChernivtsi";
      } else if (appId === "dnipro.gas") {
        distributionModule = "PaymentDistributionDnipro";
      } else if (appId === "khmelnytskyi.gas") {
        distributionModule = "PaymentDistributionKhmelnytskyi";
      } else if (appId === "kirovograd.gas") {
        distributionModule = "PaymentDistributionKirovograd";
      } else if (appId === "kyiv.gas") {
        distributionModule = "PaymentDistributionKyiv";
      } else if (appId === "lviv.gas") {
        distributionModule = "PaymentDistributionLviv";
      } else if (appId === "mykolaiv.gas") {
        distributionModule = "PaymentDistributionMykolaiv";
      } else if (appId === "prykarpattya.gas") {
        distributionModule = "PaymentDistributionPrykarpattya";
      } else if (appId === "rivne.gas") {
        distributionModule = "PaymentDistributionRivne";
      } else if (appId === "sumy.gas") {
        distributionModule = "PaymentDistributionSumy";
      } else if (appId === "ternopil.gas") {
        distributionModule = "PaymentDistributionTernopil";
      } else if (appId === "vinnytsia.gas") {
        distributionModule = "PaymentDistributionVinnytsia";
      } else if (appId === "volyn.gas") {
        distributionModule = "PaymentDistributionVolyn";
      } else if (appId === "zakarpattya.gas") {
        distributionModule = "PaymentDistributionZakarpattya";
      }
      
      return distributionModule;
    },

    handleCloseLsDistrib(lsDistrib) {
      this.showLsDistribDialog = false;
      // После добавления номера счета чекбокс не должен быть активным
      this.payDistribution = false;
      this.distributionAmount = 0;

      // // Сбрасываем флаг неверного счета через мутацию
      // this.$store.commit("PaymentDistributionHarkiv/SET_INVALID_ACCOUNT", false);

      // Обновляем объект аккаунта с новым номером счета распределения
      if (lsDistrib) {
        this.account.lsDistrib = lsDistrib;

        // Загружаем данные о долге для нового счета
        this.loadDistributionDebt();
      }

      this.$emit("update:services", this.getServicesData());
    },
    handleDistributionChange() {
      // Определяем текущий модуль распределения в зависимости от appId
      const appId = this.$store.state.Auth.app_id;
      let distributionModule = "PaymentDistributionHarkiv"; // По умолчанию Харьков

      if (appId === "cherkasy.gas") {
        distributionModule = "PaymentDistributionCherkasy";
      } else if (appId === "chernihiv.gas") {
        distributionModule = "PaymentDistributionChernihiv";
      } else if (appId === "chernivtsi.gas") {
        distributionModule = "PaymentDistributionChernivtsi";
      } else if (appId === "dnipro.gas") {
        distributionModule = "PaymentDistributionDnipro";
      } else if (appId === "khmelnytskyi.gas") {
        distributionModule = "PaymentDistributionKhmelnytskyi";
      } else if (appId === "kirovograd.gas") {
        distributionModule = "PaymentDistributionKirovograd";
      } else if (appId === "kyiv.gas") {
        distributionModule = "PaymentDistributionKyiv";
      } else if (appId === "lviv.gas") {
        distributionModule = "PaymentDistributionLviv";
      } else if (appId === "mykolaiv.gas") {
        distributionModule = "PaymentDistributionMykolaiv";
      } else if (appId === "prykarpattya.gas") {
        distributionModule = "PaymentDistributionPrykarpattya";
      } else if (appId === "rivne.gas") {
        distributionModule = "PaymentDistributionRivne";
      } else if (appId === "sumy.gas") {
        distributionModule = "PaymentDistributionSumy";
      } else if (appId === "ternopil.gas") {
        distributionModule = "PaymentDistributionTernopil";
      } else if (appId === "vinnytsia.gas") {
        distributionModule = "PaymentDistributionVinnytsia";
      } else if (appId === "volyn.gas") {
        distributionModule = "PaymentDistributionVolyn";
      } else if (appId === "zakarpattya.gas") {
        distributionModule = "PaymentDistributionZakarpattya";
      }

      // Проверяем флаг невалидного аккаунта из хранилища Vuex
      const invalidAccount = this.$store.state[distributionModule].invalidAccount;
      console.log(`invalidAccount из ${distributionModule}: `, invalidAccount);

      if (this.payDistribution) {
        // Сначала проверяем наличие счета
        if (!this.account.lsDistrib) {
          // Счет отсутствует - сразу показываем окно добавления счета
          // Сбрасываем данные о долге
          this.distributionDebt = 0;
          this.distributionAmount = 0;

          this.showLsDistribDialog = true;
          // Снимаем чекбокс, чтобы пользователь не мог продолжить без счета
          this.payDistribution = false;

          this.$emit("update:services", this.getServicesData());
          return;
        } else if (invalidAccount) {
          // Счет есть, но он неверный - показываем уведомление
          // Сбрасываем только данные о долге, но не флаг invalidAccount
          this.distributionDebt = 0;
          this.distributionAmount = 0;

          this.dialogMessage = this.$t('popup.invalidDistributionAccount');
          this.showDialog = true;

          // Снимаем чекбокс, чтобы пользователь не мог продолжить с неверным счетом
          this.payDistribution = false;

          // Окно добавления счета будет показано только после нажатия на галочку в сообщении
          this.$emit("update:services", this.getServicesData());
          return;
        } else {
          console.log("Случай 3: Счет есть и он действителен: ", this.distributionAmount);
          // Случай 3: Счет есть и он действителен
          this.distributionAmount = this.distributionDebt > 0 ? parseFloat(this.distributionDebt.toFixed(2)) : 100;
        }
      } else {
        this.distributionAmount = 0;
      }

      this.$emit("update:services", this.getServicesData());
    },
    initializeNaftogazAmount() {
      // Если чекбокс активен, устанавливаем сумму в зависимости от баланса
      if (this.payNaftogaz) {
        // Если есть долг, устанавливаем сумму долга
        // Если долг 0 или переплата (отрицательный баланс), устанавливаем 100
        if (this.account.balance > 0) {
          this.naftogazAmount = this.account.balance;
        } else {
          this.naftogazAmount = 100;
        }

        // Затем увеличиваем ключ, чтобы пересоздать компонент ввода
        this.inputKey++;

        // Обновляем список услуг
        this.$emit("update:services", this.getServicesData());
      }
    },
    handleNaftogazChange() {
      if (this.payNaftogaz) {
        // Автоматично встановлюємо суму в залежності від балансу Нафтогазу
        console.log("naftogazAmount: ", this.account.balance);

        // Если есть долг, устанавливаем сумму долга
        // Если долг 0 или переплата (отрицательный баланс), устанавливаем 100
        if (this.account.balance > 0) {
          this.naftogazAmount = this.account.balance;
        } else {
          this.naftogazAmount = 100;
        }
      } else {
        this.naftogazAmount = 0;
      }
      this.$emit("update:services", this.getServicesData());
    },
    getServicesData() {
      const services = [];
      let totalAmount = 0;

      if (this.payNaftogaz && !isNaN(parseFloat(this.naftogazAmount))) {
        // Округляем сумму до сотых
        const amount = parseFloat(parseFloat(this.naftogazAmount).toFixed(2));
        services.push({
          name: 'ГК "Нафтогаз України"',
          amount: amount,
        });
        totalAmount += amount;
      }

      if (this.payDistribution && !isNaN(parseFloat(this.distributionAmount))) {
        // Округляем сумму до сотых
        const amount = parseFloat(parseFloat(this.distributionAmount).toFixed(2));
        services.push({
          name: "Газорозподільні мережі України",
          amount: amount,
        });
        totalAmount += amount;
      }

      // Округляем общую сумму до сотых
      totalAmount = parseFloat(totalAmount.toFixed(2));

      return {
        services,
        totalAmount,
      };
    },
    updateTotal() {
      this.$emit("update:services", this.getServicesData());
    },
    runPayment() {
      // Определяем текущий модуль распределения в зависимости от appId
      const appId = this.$store.state.Auth.app_id;
      let distributionModule = "PaymentDistributionHarkiv"; // По умолчанию Харьков

      if (appId === "cherkasy.gas") {
        distributionModule = "PaymentDistributionCherkasy";
      } else if (appId === "chernihiv.gas") {
        distributionModule = "PaymentDistributionChernihiv";
      } else if (appId === "chernivtsi.gas") {
        distributionModule = "PaymentDistributionChernivtsi";
      } else if (appId === "dnipro.gas") {
        distributionModule = "PaymentDistributionDnipro";
      } else if (appId === "khmelnytskyi.gas") {
        distributionModule = "PaymentDistributionKhmelnytskyi";
      } else if (appId === "kirovograd.gas") {
        distributionModule = "PaymentDistributionKirovograd";
      } else if (appId === "kyiv.gas") {
        distributionModule = "PaymentDistributionKyiv";
      } else if (appId === "lviv.gas") {
        distributionModule = "PaymentDistributionLviv";
      } else if (appId === "mykolaiv.gas") {
        distributionModule = "PaymentDistributionMykolaiv";
      } else if (appId === "prykarpattya.gas") {
        distributionModule = "PaymentDistributionPrykarpattya";
      } else if (appId === "rivne.gas") {
        distributionModule = "PaymentDistributionRivne";
      } else if (appId === "sumy.gas") {
        distributionModule = "PaymentDistributionSumy";
      } else if (appId === "ternopil.gas") {
        distributionModule = "PaymentDistributionTernopil";
      } else if (appId === "vinnytsia.gas") {
        distributionModule = "PaymentDistributionVinnytsia";
      } else if (appId === "volyn.gas") {
        distributionModule = "PaymentDistributionVolyn";
      } else if (appId === "zakarpattya.gas") {
        distributionModule = "PaymentDistributionZakarpattya";
      }

      // Проверяем, было ли это уведомление о неверном счете
      const invalidAccount = this.$store.state[distributionModule].invalidAccount;
      console.log(`invalidAccount из ${distributionModule}:`, invalidAccount);

      // Если это было уведомление о неверном счете, показываем диалог для ввода счета
      if (invalidAccount) {
        // Сбрасываем данные о долге еще раз, чтобы гарантировать отсутствие старых данных
        this.$store.commit(`${distributionModule}/RESET_PAYMENT_STATE`);
        this.distributionDebt = 0;
        this.distributionAmount = 0;

        this.showLsDistribDialog = true;
      } else {
        this.$emit("run-payment");
      }
    },
    // Проверяет, нужно ли загружать данные о долге распределения
    shouldLoadDistributionDebt(account) {
      // Проверяем, что мы не находимся на странице списка аккаунтов
      if (this.$route.name === 'AccountsList') {
        console.log('Не загружаем долг: находимся на странице списка аккаунтов');
        return false;
      }
      
      // Проверяем, что мы находимся на странице аккаунта или на странице оплаты
      const validRoutes = ['Account', 'Pay'];
      if (!validRoutes.includes(this.$route.name)) {
        console.log(`Не загружаем долг: находимся на странице ${this.$route.name}, а не на Account или Pay`);
        return false;
      }
      
      // Проверяем, что счет существует и имеет счет распределения
      if (!account || !account.lsDistrib) {
        console.log('Не загружаем долг: отсутствует счет или счет распределения');
        return false;
      }
      
      // Проверяем, что есть идентификатор приложения
      const appId = this.$store.state.Auth.app_id;
      
      if (!appId) {
        console.log('Не загружаем долг: отсутствует идентификатор приложения');
        return false;
      }
      
      return true;
    },
    
    
    async loadDistributionDebt() {
      // Проверяем, нужно ли загружать данные
      if (!this.shouldLoadDistributionDebt(this.account)) {
        console.log('Пропускаем загрузку долга распределения: счет не соответствует критериям');
        return;
      }
      
      console.log(`loadDistributionDebt`, JSON.stringify(this.account.city));

      // Определяем текущий модуль распределения в зависимости от appId
      const appId = this.$store.state.Auth.app_id;
      let distributionModule = this.getDistributionModule(appId); // Используем вспомогательный метод

      // Сбрасываем только локальные данные о задолженности, не трогая флаг invalidAccount
      // Не используем RESET_PAYMENT_STATE, чтобы не сбросить флаг invalidAccount
      this.$store.commit(`${distributionModule}/SET_PAYMENT_URL`, null);
      this.$store.commit(`${distributionModule}/SET_PAYMENT_RESPONSE`, null);
      this.$store.commit(`${distributionModule}/SET_PROCESSING_3DS`, false);
      this.$store.commit(`${distributionModule}/SET_DISTRIBUTION_DEBT`, 0);

      this.distributionDebt = 0;
      this.payDistribution = false;
      this.distributionAmount = 0;
      // Флаг invalidAccount теперь управляется в хранилище Vuex и мы его не трогаем

      if (!this.account.lsDistrib) return;

      this.loadingDistributionDebt = true;
      try {
        // Получаем действие для загрузки долга в зависимости от appId и города
        let actionName;
        
        // Определяем действие для загрузки долга в зависимости от региона и города
        switch (appId) {
          case "kharkiv.gas":
            actionName = this.account.city === "Харків" ? 
              "getHarkivAccountDistributionDebt" : 
              "getHarkivRegionAccountDistributionDebt";
            break;
          case "dnipro.gas":
            actionName = this.account.city === "Дніпро" ? 
              "getDniproAccountDistributionDebt" : 
              "getDniproRegionAccountDistributionDebt";
            break;
          case "cherkasy.gas":
            actionName = "getCherkasyAccountDistributionDebt";
            break;
          case "chernihiv.gas":
            actionName = "getChernihivAccountDistributionDebt";
            break;
          case "chernivtsi.gas":
            actionName = "getChernivtsiAccountDistributionDebt";
            break;
          case "khmelnytskyi.gas":
            actionName = "getKhmelnytskyiAccountDistributionDebt";
            break;
          case "kirovograd.gas":
            actionName = "getKirovogradAccountDistributionDebt";
            break;
          case "kyiv.gas":
            actionName = "getKyivAccountDistributionDebt";
            break;
          case "lviv.gas":
            actionName = "getLvivAccountDistributionDebt";
            break;
          case "mykolaiv.gas":
            actionName = "getMykolaivAccountDistributionDebt";
            break;
          case "prykarpattya.gas":
            actionName = "getPrykarpattyaAccountDistributionDebt";
            break;
          case "rivne.gas":
            actionName = "getRivneAccountDistributionDebt";
            break;
          case "sumy.gas":
            actionName = "getSumyAccountDistributionDebt";
            break;
          case "ternopil.gas":
            actionName = "getTernopilAccountDistributionDebt";
            break;
          case "vinnytsia.gas":
            actionName = "getVinnytsiaAccountDistributionDebt";
            break;
          case "volyn.gas":
            actionName = "getVolynAccountDistributionDebt";
            break;
          case "zakarpattya.gas":
            actionName = "getZakarpattyaAccountDistributionDebt";
            break;
          // Регионы в разработке
          case "zaporizhzhia.gas":
          case "kherson.gas":
          case "poltava.gas":
          case "odesa.gas":
          case "zhytomyr.gas":
            console.log(`Сервис для региона ${appId} находится в разработке`);
            this.distributionDebt = 0;
            return;
          default:
            // По умолчанию используем Харьков
            actionName = "getHarkivAccountDistributionDebt";
            distributionModule = "PaymentDistributionHarkiv";
            break;
        }
        
        // Вызываем действие для загрузки долга только для текущего активного модуля
        console.log(`Загрузка долга распределения для ${distributionModule} с действием ${actionName}`);
        await this.$store.dispatch(`${distributionModule}/${actionName}`, {ls: this.account.lsDistrib});
        
        // Проверяем ответ на наличие ошибки
        const error = this.$store.state[distributionModule].error;
        if (error && error.status === "error") {
          console.error(`Ошибка получения долга распределения для ${appId}:`, error);
          return;
        }
        
        // Получаем значение долга из хранилища
        const debt = this.$store.state[distributionModule].distributionDebt;
        this.distributionDebt = debt;
        
        // Устанавливаем сумму платежа: если долг > 0, то округляем его до сотых, иначе 100 грн
        if (this.payDistribution) {
          this.distributionAmount = debt > 0 ? parseFloat(debt.toFixed(2)) : 100;
        }
      } catch (error) {
        console.error("Error fetching distribution debt:", error);
        this.distributionDebt = 0;
        
        // Устанавливаем сумму платежа по умолчанию (100 грн) если чекбокс активен
        if (this.payDistribution) {
          this.distributionAmount = 100;
        } else {
          this.distributionAmount = 0;
        }
        
        // Устанавливаем флаг невалидного аккаунта только в текущем активном модуле
        const appId = this.$store.state.Auth.app_id;
        const distributionModule = this.getDistributionModule(appId);
        
        // Устанавливаем флаг невалидного аккаунта только для активного модуля
        console.log(`Установка флага invalidAccount = true для модуля ${distributionModule}`);
        this.$store.state[distributionModule].invalidAccount = true;
      } finally {
        this.loadingDistributionDebt = false;
      }
    },
  }
};
</script>
<style scoped>
.home-account {
  border-radius: 15px 15px 15px 15px;
  max-width: 377px;
  margin-top: -1px;
  box-shadow: none !important;
}

.home-account * {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
}

.place-content-left {
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-header {
  text-align: left;
  margin-bottom: 20px;
}

.account-number {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #ffffff;
}

.account-street {
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin-bottom: 5px;
}

.account-apartment {
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin-bottom: 5px;
}

.account-city {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 5px;
}

.account-balance {
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 20px;
  color: #ffffff;
}

.positive-balance {
  color: #e3626e;
}

.negative-balance {
  color: #0f0;
}

.services-info-block {
  margin-top: 10px;
  text-align: left;
}

.service-block {
  margin-bottom: 25px;
}

.service-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #ffffff;
}

.service-company {
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin-bottom: 6px;
}

.service-region, .service-note {
  font-size: 16px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 6px;
}

.checkbox-group {
  margin-top: 15px;
}

.service-item {
  margin-bottom: 15px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.service-label {
  display: flex;
  flex-direction: column;
}

.service-label span:first-child {
  font-weight: 500;
  color: #fff;
}

.service-label .account-number {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 3px 0;
}

.debt-amount {
  font-size: 14px;
}

.positive {
  color: #e3626e;
}

.negative {
  color: #4CD964;
}

.amount-input {
  margin-top: 10px;
  max-width: 200px;
}

/* Стили для чекбоксов */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 2px solid #4285F4;
  border-radius: 3px;
}

.checkbox-label:hover .checkmark {
  border-color: #4477f6;
}

.checkbox-input:checked ~ .checkmark {
  background-color: #4285F4;
  border-color: #4285F4;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-label .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.arrow-indicator {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.7;
}

.home-account {
  position: relative;
}

/* Стили для карточки Идея Банк */
.idea-bank-card {
  width: 100%;
  border-radius: 8px;
  color: #fff;
  overflow: hidden;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.pink-banner {
  border-radius: 10px;
  width: 100%;
  background-color: #d024b7;
  padding-bottom: 15px;
}

.card-license {
  font-size: 8px;
  color: rgba(255, 255, 255, 0.9);
  padding: 5px 10px;
  line-height: 1.2;
}

.card-title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 5px 10px 10px;
  line-height: 1.3;
}

.card-right-block {
  position: absolute;
  top: 85px;
  right: 25px;
  width: 40%;
  display: flex;
  flex-direction: column;

  transform-origin: top center;

  animation: swing 3s infinite ease-in-out;
}

@keyframes swing {
  0%   { transform: rotate(-10deg); }
  50%  { transform: rotate(10deg); }
  100% { transform: rotate(-10deg); }
}

.card-image {
  width: 100%;
}

.card-image img {
  width: 100%;
  height: auto;
  transform: rotate(0deg);
  border-radius: 10px;
}

.card-promo {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 5px 0;
  text-align: left;
}

.hourglass {
  font-size: 16px;
}

.promo-text {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.promo-star {
  font-size: 16px;
}

.promo-block {
  text-align: left;
  padding: 0 10px;
  max-width: 200px;
  height: auto;
}

.timer {
  margin:0;
  font-size: 14px;
}

.time-value {
  color: #e89016;
  font-weight: 700;
  display: inline-block;
}

.card-timer {
  margin: 5px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-align: left;
  margin-block-start: 0;
  margin-block-end: 0;
}

.card-timer span {
  font-weight: 600;
}

.terms-link {
  color: #2991cb !important;
  cursor: pointer;
  margin:0;
  text-align: left;
  display: block;
}

.card-terms {
  margin: 5px 10px;
  font-size: 14px;
  color: #4285F4;
  text-decoration: underline;
  cursor: pointer;
}

.card-number {
  margin: 5px 10px;
  font-size: 14px;
  font-weight: 600;
}

.card-yellow-block {
  position: relative;
  margin-top: -25px;
  background-color: #ffde59;
  color: #000;
  border-radius: 12px;
  font-size: 8px;
  padding: 8px;
  z-index: 20;
}

.card-yellow-block div {
  margin-bottom: 3px;
}

.card-button {
  display: block;
  width: calc(100% - 20px);
  margin: 10px;
  padding: 10px 0;
  background-color: #fff;
  color: #000;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  text-transform: uppercase;
}

.card-button:hover {
  filter: brightness(90%);
}

/* Анимация появления карточки */
.card-fade-enter-active {
  animation: card-appear 0.5s ease-out;
}

.card-fade-leave-active {
  animation: card-appear 0.5s ease-in reverse;
}

@keyframes card-appear {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
